import { Controller } from "@hotwired/stimulus"
import { claimFloatingTooltip, hideFloatingTooltip } from "../utils/floating_tooltip"

let activeController = null

export default class extends Controller {
  static values = {
    label: String,
    count: Number,
    percentage: Number,
    percentageLabel: String,
    color: String,
    title: String
  }

  show(event) {
    activeController = this
    const anchor = event.currentTarget
    const tooltip = claimFloatingTooltip(anchor)

    tooltip.innerHTML = this.buildHtml()
    tooltip.classList.remove("is-visible")

    tooltip.style.display = "block"
    tooltip.style.visibility = "hidden"
    tooltip.style.opacity = "0"
    tooltip.style.left = "-9999px"
    tooltip.style.top = "-9999px"
    tooltip.style.transform = "none"

    const tooltipRect = tooltip.getBoundingClientRect()
    const anchorRect = anchor.getBoundingClientRect()
    const { left, top } = this.computePosition(anchorRect, tooltipRect)

    tooltip.style.left = `${left}px`
    tooltip.style.top = `${top}px`
    tooltip.style.visibility = ""
    tooltip.style.opacity = ""
    tooltip.classList.add("is-visible")
  }

  hide() {
    if (activeController !== this) return

    hideFloatingTooltip({ force: true })
    activeController = null
  }

  buildHtml() {
    const title =
      this.hasTitleValue && this.titleValue
        ? `<div class="chart-segment-tooltip__title">${this.escapeHtml(this.titleValue)}</div>`
        : ""

    if (!this.hasCountValue) {
      return `${title}<div class="chart-segment-tooltip__label">${this.escapeHtml(this.labelValue)}</div>`
    }

    const count = this.formatCount(this.countValue)
    const marker = this.colorValue
      ? `<span class="chart-segment-tooltip__marker" style="background-color: ${this.colorValue};"></span>`
      : `<span class="chart-segment-tooltip__marker chart-segment-tooltip__marker--muted"></span>`

    const percentageSuffix =
      this.hasPercentageLabelValue && this.percentageLabelValue
        ? ` ${this.escapeHtml(this.percentageLabelValue)}`
        : ""

    const percentage =
      this.hasPercentageValue && !Number.isNaN(this.percentageValue)
        ? `<span class="chart-segment-tooltip__percentage">${this.formatPercentage(this.percentageValue)} %${percentageSuffix}</span>`
        : ""

    return `${title}<div class="chart-segment-tooltip__row">${marker}<div class="chart-segment-tooltip__content"><div class="chart-segment-tooltip__label">${this.escapeHtml(this.labelValue)}</div><div class="chart-segment-tooltip__metrics"><strong class="chart-segment-tooltip__value">${count}</strong>${percentage}</div></div></div>`
  }

  computePosition(anchorRect, tooltipRect) {
    const gap = 8
    let left = anchorRect.left + anchorRect.width / 2 - tooltipRect.width / 2
    let top = anchorRect.top - tooltipRect.height - gap

    if (top < gap) top = anchorRect.bottom + gap

    left = Math.max(gap, Math.min(left, window.innerWidth - tooltipRect.width - gap))
    top = Math.max(gap, Math.min(top, window.innerHeight - tooltipRect.height - gap))

    return { left, top }
  }

  formatCount(value) {
    return Number(value).toLocaleString("fr-FR")
  }

  formatPercentage(value) {
    return Number(value).toLocaleString("fr-FR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 1
    })
  }

  escapeHtml(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
  }
}
